import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  AdjacentCoursePauseRequestButton,
  ADJACENT_COURSE_PAUSE_REQUEST_TYPE,
  CoursePauseBatchLecturesList,
  CoursePauseLearnerLecturesList,
  LearnerEmailBadge,
  setViewLectureModalState,
  setSelectedSuperBatch,
  selectedRequestSelector,
  selectedSuperBatchSelector,
  viewLectureModalStateSelector,
} from 'features/courseResume';
import styles from './ViewLectureModal.module.scss';
import ViewLectureSuperBatchSelect from '../ViewLectureSuperBatchSelect';

function ViewLectureModal() {
  const dispatch = useDispatch();
  const selectedSuperBatch = useSelector(selectedSuperBatchSelector);
  const isModalOpen = useSelector(viewLectureModalStateSelector);
  const selectedRequest = useSelector(selectedRequestSelector);
  const {
    source_batch: sourceBatch,
    pause_date: pauseDate,
    expected_resume_date: resumeDate,
    meta,
    mentee,
  } = selectedRequest || {};
  const { super_batch: sourceSuperBatch } = sourceBatch || {};
  const {
    suggested_sb_id: suggestedSbatId,
    suggested_sb_name: suggestedSbatName,
  } = meta || {};

  useEffect(() => {
    if (suggestedSbatId) {
      dispatch(
        setSelectedSuperBatch({
          id: suggestedSbatId,
          name: suggestedSbatName,
        })
      );
    }
  }, [dispatch, suggestedSbatId, suggestedSbatName]);

  const handleClose = useCallback(() => {
    batch(() => {
      dispatch(setViewLectureModalState(false));
      dispatch(setSelectedSuperBatch(null));
    });
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleClose}
      size="extraLarge"
      withoutHeader
    >
      <div className={styles.root}>
        <div className="h4 primary bold m-b-xs">VIEW LECTURES</div>
        <ViewLectureSuperBatchSelect selectedSuperBatch={selectedSuperBatch} />
        <LearnerEmailBadge email={mentee?.user.email} />
        <div className={styles.listSection}>
          <div className={styles.lectureList}>
            <div className="h6">CURRENT</div>
            <CoursePauseLearnerLecturesList
              superBatch={sourceSuperBatch}
              request={selectedRequest}
              referenceDate={pauseDate}
            />
          </div>
          <div className={styles.lectureList}>
            <div className="h6">NEW</div>
            {selectedSuperBatch && (
              <CoursePauseBatchLecturesList
                superBatch={selectedSuperBatch}
                coursePauseRequest={selectedRequest}
                referenceDate={Math.max(new Date(resumeDate), new Date())}
              />
            )}
          </div>
        </div>
        <div className="row justify-c align-c m-t-xs">
          <AdjacentCoursePauseRequestButton
            type={ADJACENT_COURSE_PAUSE_REQUEST_TYPE.previous}
          />
          <AdjacentCoursePauseRequestButton
            type={ADJACENT_COURSE_PAUSE_REQUEST_TYPE.next}
          />
        </div>
      </div>
    </Modal>
  );
}

export default ViewLectureModal;
